import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wine } from "lucide-react";

export default function Register() {
  const { register, error } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", bar_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(form);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#0a0c10]">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-md bg-amber-500 flex items-center justify-center">
            <Wine className="w-5 h-5 text-black" />
          </div>
          <div className="font-display text-xl font-bold">
            Barkeep<span className="text-amber-500">.</span>
          </div>
        </div>

        <div className="text-xs uppercase tracking-widest text-amber-500 font-mono-plex mb-3">
          Get started
        </div>
        <h1 className="font-display text-3xl font-bold">Create your bar</h1>
        <p className="text-slate-500 text-sm mt-1 mb-8">
          Two minutes. Your inventory command center is ready after.
        </p>

        <form onSubmit={handleSubmit} className="space-y-3" data-testid="register-form">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-slate-400 mb-1 block">Your name</label>
              <input
                required
                value={form.name}
                onChange={onChange("name")}
                data-testid="register-name"
                className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500"
              />
            </div>
            <div>
              <label className="text-xs text-slate-400 mb-1 block">Bar name</label>
              <input
                value={form.bar_name}
                onChange={onChange("bar_name")}
                data-testid="register-bar"
                className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500"
                placeholder="The Emerald Room"
              />
            </div>
          </div>
          <div>
            <label className="text-xs text-slate-400 mb-1 block">Email</label>
            <input
              type="email"
              required
              value={form.email}
              onChange={onChange("email")}
              data-testid="register-email"
              className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500"
            />
          </div>
          <div>
            <label className="text-xs text-slate-400 mb-1 block">Password</label>
            <input
              type="password"
              required
              minLength={6}
              value={form.password}
              onChange={onChange("password")}
              data-testid="register-password"
              className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500"
            />
          </div>

          {error && (
            <div
              className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2"
              data-testid="register-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="btn-amber w-full rounded-md py-2.5 disabled:opacity-60"
          >
            {loading ? "Creating…" : "Create account"}
          </button>

          <div className="text-sm text-slate-500 text-center pt-2">
            Already have an account?{" "}
            <Link to="/login" className="text-amber-500 hover:text-amber-400" data-testid="go-to-login">
              Sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
